import React from 'react';
import {Entry, Info} from './components/Entry';

const App = () => {
    return (
        <div>
            <Entry />
            <Info />
        </div>
    );
};

export default App;